import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Grid, Stack } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import Title from "../../common/Title";
import Search from "../Search/Search";
import useBatchListState from "../../../hooks/useBatchListState";
import { OPERATIONS } from "../../../constants/value";
import { __getOrderInfoBatches } from "../../../api/sim";
import BatchList from "../../common/BatchList";

const OrderInfo = ({ client }) => {
  const [searchActive, setSearchActive] = useState(false);

  const nav = useNavigate();

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getOrderInfoBatches, { client });

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        sx={{ textTransform: "capitalize" }}
        content={`${client ? client : ""} Order Info`}
        gutterBottom
      />

      <Grid container justifyContent="space-between" spacing={2} mb={2}>
        <Grid item>
          <Stack spacing={2} direction="row">
            <LoadingButton
              loading={loading}
              variant="contained"
              color="primary"
              onClick={() => nav("form")}
            >
              Fetch Order Info
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>

      <Search
        key={`${client}-order-info-search`}
        client={client}
        operation={OPERATIONS.order_info}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />

      {!searchActive && response ? (
        <BatchList
          data={data}
          loading={loading}
          meta={metaData}
          statusCategories={statusCategories}
          onStatusCategoryChange={handleStatusCategoryChange}
          handlePageChange={handlePageChange}
          handlePageSizeChange={handlePageSizeChange}
        />
      ) : !searchActive ? (
        <Title content="Please wait..." variant="subtitle2" gutterBottom />
      ) : null}
    </Box>
  );
};

export default OrderInfo;
